import React from 'react';

import { Dashboard as DashboardLayout } from 'layouts';

import { Portlet, PortletContent } from 'components';

import { makeStyles } from '@mui/styles';

import { FormStepper } from './components';

import styles from './styles';
import { useParams } from 'react-router-dom';
const useStyle = makeStyles(styles);

export default function NewVoltage() {
  const classes = useStyle();
  const { groupId, meterId } = useParams();

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <Portlet>
          <PortletContent>
            <FormStepper meterId={meterId} groupId={groupId} />
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
